import React from "react";
import { Tag, Tooltip } from "antd";
import { ROLES, RoleKey } from "./rolesConfig";

export default function RolesStatusTag({ role }: { role?: RoleKey }) {
  const config = role ? ROLES[role] : undefined;

  if (!config) {
    return (
      <Tag color="#00000040" className="justify-self-start w-fit">
        UNKNOWN
      </Tag>
    );
  }

  return (
    <Tooltip title={config.description[0]}>
      <Tag
        color={config.color}
        variant="solid"
        className="justify-self-start w-fit"
      >
        <span className="text-white">{config.shortLabel}</span>
      </Tag>
    </Tooltip>
  );
}
